import React, { PureComponent } from 'react'
import PropTypes from 'prop-types';
import tagsConfigHelper from '../../../helpers/tagsConfigHelper'
import ControlManager from '../ControlManager'
import {
    START_VALIDATE_TAGS,
    ADD_TAG_ERROR
}
from '../../../redux/actions/actionTypes'

class TextArea extends PureComponent {
    constructor(props) {
        super(props)

        this.textAreaRef = React.createRef();

        this.state ={}

        this.initState=this.initState.bind(this)
        this.initControl = this.initControl.bind(this)
        const validate= this.validate.bind(this)

        this.initState()
        
        // window.emitter.addListener(START_VALIDATE_TAGS, function (message) {
        //     validate()
        // })
    }

    initState(){
        let {doctype}=this.props

        this.state={
            visible: true,
            disabled: (!doctype || doctype=="")?this.props.disabled:false,
            required:false,
            description:null,
            error:false,
            error_message:null
        }
    }
    
    initControl() {
        let {doctype,tagid}=this.props
       
        if (!doctype || !tagid) return
        
        var tagInfo = tagsConfigHelper.findTagConfig(tagid, doctype)

            if(tagInfo){
                this.setState({
                    visible:tagInfo.visibled,
                    disabled: !tagInfo.enabled,
                    required:tagInfo.required,
                    description:tagInfo.tagDescription
                })

                ControlManager.setLabel(tagInfo.tagLabel,tagInfo.visibled,tagInfo.required)
                ControlManager.setSubLabel(tagInfo.tagSubLabel,tagInfo.visibled)
            }
    }
    
    async validate() {
        let {required,description}=this.state
        let {tagid}=this.props
        let control=this.textAreaRef.current

        if(!control || !tagid || !required) return

        //console.log("validate : ",tagid)

        this.setState({
            error: false,
            error_message: null
        })
        
        if(!control.value || control.value.length===0){
            let message="กรุณาระบุ " + (description!==null ? description :tagid)

            this.setState({
                error:true,
                error_message: message
            })

         window.emitter.emit(ADD_TAG_ERROR, {
            tagId:tagid,
            description:description,
            error_message:this.state.error_message
        })
        }  
    }

    componentWillReceiveProps(nextProps) {        
        if (this.props.doctype !== nextProps.doctype) {
               this.initControl()
        }

        //กรณีไม่ได้กำหนด DocType บางค่าให้เชื่อตามที่กำหนดจากข้างนอก
        if(!nextProps.doctype || nextProps.doctype===""){
            if (this.state.disabled !== nextProps.disabled) {
                this.setState({disabled:nextProps.disabled})
            }
        }
    }

    componentDidMount(){
        this.initControl()
    }

    render() {
        let {disabled,visible}=this.state

        return (
            <textarea
                ref={this.textAreaRef}
                {...this.props}
                className={["form-control",this.props.className].join(' ')}
                disabled={disabled?"disabled":null}
                style={{visibility: visible?"visible":"hidden"}}
            />
        )
    }
}

TextArea.defaultProps = {
}

TextArea.propTypes = {
    doctype: PropTypes.string,
    tagid: PropTypes.string
}


export default TextArea;